import { render, staticRenderFns } from "./BeforeEvent.vue?vue&type=template&id=2c604ef3&"
import script from "./BeforeEvent.vue?vue&type=script&lang=js&"
export * from "./BeforeEvent.vue?vue&type=script&lang=js&"
import style0 from "./BeforeEvent.vue?vue&type=style&index=0&id=2c604ef3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports